import { DeviceItem, MyProduct } from 'src/model/api/v2/data-contracts';

export interface PlaceableDevice {
    id: string;
    type: string;
    text: string;
    icon: string | null;
    groupable: boolean;
    is_loxone: boolean;
}

export function mapDeviceItemToPlaceable(device: DeviceItem): PlaceableDevice {
    return {
        id: `product_${device.id}`,
        type: 'device',
        text: device.text,
        icon: device.icon ?? device.image_url ?? null,
        groupable: device.groupable,
        is_loxone: device.is_loxone,
    };
}

export function mapMyProductToPlaceable(product: MyProduct): PlaceableDevice {
    const iconDataUrl = product.icon_svg ? `data:image/svg+xml;base64,${btoa(product.icon_svg)}` : null;
    return {
        id: `user_custom_item_${product.userCustomItem.id}`,
        type: 'custom_device',
        text: product.userCustomItem.product_name,
        icon: iconDataUrl,
        groupable: false,
        is_loxone: false,
    };
}